<!-- eslint-disable -->
<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Товары</h3>
                        <div class="card-toolbar">
                            <b-button @click="addProduct" variant="primary">Создать товар</b-button>
                        </div>
                    </div>
                    <div class="card-body pt-0">

                        <b-button v-b-toggle.filter-products variant="primary">Открыть фильтр</b-button>
                        <b-collapse id="filter-products" class="mt-5">

                            <div class="mb-10">
                                <div class="row align-items-center">
                                    <div class="col-lg-12 col-xl-12">
                                        <div class="row align-items-center">

                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Поиск по имени или артикулу</label>
                                                <div class="input-icon">
                                                    <input v-model.trim="filter.search" type="text" class="form-control form-control-solid" placeholder="Поиск.." id="kt_datatable_search_query" />
                                                    <span><i class="flaticon2-search-1 text-muted"></i></span>
                                                </div>
                                            </div>

<!--                                            <div class="col-md-4 my-2 my-md-0">
                                                <label>Категория</label>
                                                    <b-form-select  v-model="filter.category" class="form-control form-control-solid">
                                                        <option :value="null">Выбрать</option>
                                                        <template v-for="(category, i) in categories" >
                                                            <b-form-select-option-group v-bind:key="i" :label="category.name">
                                                                <template v-for="(children, index) in category.children_categories" >
                                                                    <b-form-select-option v-bind:key="index" :value="children.id">{{children.name}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select-option-group>
                                                        </template>
                                                    </b-form-select>

                                            </div>-->

                                        </div>
                                        <div class="row align-items-center mt-3">
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Цена от</label>
                                                <input class="form-control form-control-solid"
                                                       type="text"
                                                       v-model.number="filter.price_from">
                                            </div>
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Цена до</label>
                                                <input class="form-control form-control-solid"
                                                       type="text"
                                                       v-model.number="filter.price_to">
                                            </div>
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="status">Статус</label>
                                                <select v-model="filter.status" class="form-control form-control-solid" id="status">
                                                    <option :value="null">Выбрать</option>

                                                    <option value="in_stock">В наличии</option>
                                                    <option value="for_order">Предзаказ</option>

                                                </select>
                                            </div>
                                        </div>
                                        <div class="row align-items-center mt-3">
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Количество от</label>
                                                <input class="form-control form-control-solid"
                                                       type="text"
                                                       v-model.number="filter.stock_from">
                                            </div>
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Количество до</label>
                                                <input class="form-control form-control-solid"
                                                       type="text"
                                                       v-model.number="filter.stock_to">
                                            </div>
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="sort">Сортировка по</label>
                                                <select v-model="filter.sort" class="form-control form-control-solid" id="sort">

                                                    <option value="data-new">По дате (новые)</option>
                                                    <option value="data-old">По дате (старые)</option>
                                                    <option value="price-high">По цене (от низкой)</option>
                                                    <option value="data-low">По цене (от высокой)</option>


                                                </select>
                                            </div>
                                        </div>

                                        <div class="mt-4">
                                        <b-link  v-b-toggle.attribute-filter >Фильтр по атрибутам</b-link>
                                        </div>

                                        <b-collapse id="attribute-filter" class="mt-2">
                                            <div class="card card-custom gutter-b">
                                                <!--begin::Body-->
                                                <div class="card-body">
                                                        <!--begin::Categories-->
                                                        <div v-bind:key="i" v-for="(attribute, i) in filter.attributes"  class="form-group mb-2">
                                                            <label class="font-size-h3 font-weight-bolder text-dark mb-0"><b-link  v-b-toggle="'accordion'+attribute.id" >{{attribute.name}}</b-link></label>
                                                            <b-collapse :id="'accordion'+attribute.id" class="mt-2">
                                                            <div class="checkbox-list">
                                                                <label v-bind:key="i" v-for="(option, i) in attribute.options" class="checkbox checkbox-lg mb-7">
                                                                    <input v-model="attribute.options_filter" :value="option" type="checkbox" name="electronics" />
                                                                    <span></span>
                                                                    <div class="font-size-lg text-dark-75 font-weight-bold">{{option.name}}</div>
                                                                </label>
                                                            </div>

                                                            </b-collapse>
                                                        </div>
                                                </div>
                                            </div>
                                        </b-collapse>

                                    </div>
                                    <div class="col-12 mt-5">
                                        <b-button @click="getFilter" class="mr-3" variant="primary">Применить</b-button>

                                        <a @click="resetFilter" class="btn btn-light-primary  font-weight-bold">
                                            Сбросить
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </b-collapse>



                        <div v-if="products.length === 0" class="text-center mb-10">
                            Товары не найдены! <a href="#" @click="resetFilter">Сбросьте фильтры</a>
                        </div>

                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                        <b-form v-else>

                                <!--begin::Table-->
                                <div  class="table-responsive mt-3">
                                    <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
                                        <thead>
                                        <tr class="text-left">
                                            <th class="pl-0">
                                                <label class="checkbox checkbox-lg checkbox-inline mr-2">
                                                    <input type="checkbox"
                                                           v-model="selectAll"
                                                    />
                                                    <span></span>
                                                </label>
                                            </th>
                                            <th class="pl-0">Название</th>
                                            <th>Цена</th>
                                            <th>Категория</th>
                                            <th>Дата добавления


                                            <th>Статус</th>
                                            <th class="pr-0 text-right" style="min-width: 110px;">Действия</th>
                                        </tr>
                                        </thead>


                                        <tbody>
                                        <template v-for="(product, i) in products">
                                            <tr>
                                                <td class="pl-0 py-6">
                                                    <label class="checkbox checkbox-lg checkbox-inline">
                                                        <input type="checkbox"
                                                               v-model="selected"
                                                               :value="product.id"
                                                        />
                                                        <span></span>
                                                    </label>
                                                </td>
                                                <td class="pl-0">
                                                    <div class="d-flex align-items-center">
                                                        <div class="symbol symbol-50 flex-shrink-0 mr-4">
                                                            <div class="symbol-label"
                                                                 :style="{ backgroundImage: 'url(' + $urlBackEnd(product.images[0].thumbnail) + ')' }">
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <router-link :to="{ name: 'FormProduct', params: {action: 'edit', id: product.id}}" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{product.title}}</router-link>
                                                            <span class="text-muted font-weight-bold d-block"> {{product.stock}} шт.</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span class="text-primary font-weight-bolder d-block font-size-lg">
                                                        {{ numberWithSpaces(product.price) }} руб.
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="product.categories.length > 0" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                        <template v-for="category in product.categories">
                                                            {{category.name}} <br>
                                                        </template>
                                                    </span>
                                                    <span v-if="product.sub_categories.length > 0" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                        <template v-for="category in product.sub_categories">
                                                            {{category.name}} <br>
                                                        </template>
                                                    </span>
                                                    <span v-if="product.sub_sub_categories.length > 0" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                        <template v-for="category in product.sub_sub_categories">
                                                            {{category.name}} <br>
                                                        </template>
                                                    </span>
                                                    <span v-if="product.categories.length === 0 && product.sub_categories.length === 0 && product.sub_sub_categories.length === 0" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                        Нет категории
                                                    </span>

                                                </td>
                                                <td>
                                                    <span class="text-primary font-weight-bolder d-block font-size-lg">
                                                        {{ moment(product.created_at).format('ll') }}
                                                    </span>
                                                    <span class="text-muted font-weight-bold">
                                                        {{ moment(product.created_at).startOf('day').fromNow() }}
                                                    </span>
                                                </td>

                                                <td>
                                                    <span v-if="product.type === 'in_stock'" class="label label-lg label-light-primary label-inline">В наличии</span>
                                                    <span v-if="product.type === 'for_order'" class="label label-lg label-light-warning label-inline">Предзаказ</span>
                                                </td>
                                                <td class="pr-0 text-right">
                                                    <router-link :to="{ name: 'FormProduct', params: {action: 'edit', id: product.id}}" v-b-tooltip.hover title="Редактировать товар" class="btn btn-icon btn-light btn-hover-primary btn-sm"><i class="fas fa-edit"></i></router-link>
                                                    <b-link @click="showModal(product.title,  product.id)" v-b-tooltip.hover title="Удалить товар" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-alt"></i></b-link>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                                <!--end::Table-->

                            <div class="row align-items-center mb-3">
                                <div class="col-lg-12 col-xl-12">
                                    <div class="row align-items-center">
                                        <div class="col-md-4 my-2 my-md-0">
                                        <b-form-select
                                                class="mb-2 mr-sm-2 mb-sm-0"
                                                :value="null"
                                                v-model="actions"
                                        >
                                                <option :value="null">Выберите действие</option>
                                                <option value="del">Удалить выбранные в корзину</option>
                                        </b-form-select>
                                        </div>
                                        <div class="col-md-4 my-2 my-md-0">
                                        <b-button @click="moreActions" variant="primary">Применить</b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Paginate :route_link="'Products'" :filter="filter" />

                        </b-form>

                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="delete-modal" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить товар: {{modalProduct.title}}?</h3>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideModal">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="outline-danger" block @click="deleteProduct(modalProduct.id)">Удалить</b-button>
                </b-col>
            </b-row>

        </b-modal>

    </div>
</template>

<script>

    import moment from "moment";
    require('moment/locale/ru');
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {GET_PRODUCTS, DELETE_PRODUCT, MORE_DELETE_PRODUCTS} from "@/core/services/store/products.module";
    import {GET_SELECT} from "@/core/services/store/categories.module";
    import {SET_ALERT} from "@/core/services/store/alert.module";
    import {GET_ATTRIBUTES} from "../../../core/services/store/attributes.module";
    import Paginate from "../Paginate";

    export default {
        name: "Products",
        components: {Paginate},
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Все товары" }]);
            this.getFilter();
            this.$store.dispatch(GET_SELECT);
            this.$store.dispatch(GET_ATTRIBUTES)
                .then(() => {
                    this.getAttributesToFilter()
                })
        },
        computed: {
            ...mapGetters({
                products: 'gettersProducts',
                paginate: 'paginateGetters',
                load: 'getProductLoad',
                categories: 'getSelectCategory',
                attributes: 'gettersAttributes'
            }),

            selectAll: {
                get: function () {
                    return this.products ? this.selected.length == this.products.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.products.forEach(function (products) {
                            selected.push(products.id);
                        });
                    }

                    this.selected = selected;
                }
            }

        },

        methods:{
            addProduct(){
                this.$router.push({ name: "FormProduct", params: {action: 'add'} })
            },

            numberWithSpaces(x){
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },

            async getFilter(){
                try {
                    await this.$store.dispatch(GET_PRODUCTS, {'page': this.$route.params.page, 'filter': this.filter});
                    if (this.products.length === 0 && this.paginate.total >= 0){
                        this.$router.push({ name: 'Products', params: {page: 1}})
                    }
                } catch (e) {
                    this.showAlert('Ошибка загрузки', 'danger', 'toast');
                }
            },

            resetFilter(){
                const reset_filter = {
                    to: '50',
                    price_from: '',
                    price_to: '',
                    new: false,
                    sale: false,
                    search: '',
                    category: null,
                    sub_category: null,
                    status: null,
                    stock_from: '',
                    stock_to: '',
                    sort: 'data-new',
                    trashed: false,
                    attributes: []
                };

                this.filter = reset_filter;
                this.getAttributesToFilter()
                this.getFilter()
            },


            deleteProduct(id){
                this.$store.dispatch(DELETE_PRODUCT, id)
                    .then(() => {
                        this.getFilter();
                        this.showAlert('Товар успешно удален (перемещен в архив)', 'success', 'toast');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка удаления', 'danger', 'toast');
                    })
                    .finally(() => {
                        this.hideModal()
                    })
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            showModal(title, id) {
                this.modalProduct = {
                    'title': title,
                    'id': id
                };
                this.$refs['delete-modal'].show()
            },

            hideModal() {
                this.modalProduct = {};
                this.$refs['delete-modal'].hide()
            },

            getAttributesToFilter(){
                this.filter.attributes = this.lodash.cloneDeep(this.attributes);
                var vue = this;
                this.filter.attributes.forEach(function (attribute) {
                    vue.$set(attribute, 'options_filter', []);
                });
            },

            moreActions(){

                if (this.actions === null){

                    this.showAlert('Необходимо выбрать действие', 'warning', 'toast');
                }

                if (this.actions === "del" && this.selected.length > 0 ) {
                    this.$store.dispatch(MORE_DELETE_PRODUCTS, this.selected)
                        .then(() => {
                            this.getFilter();
                            this.showAlert('Товары успешно удалены (перемещены в архив)', 'success', 'toast');
                        })
                        .catch(() => {
                            this.showAlert('Ошибка удаления', 'danger', 'toast');
                        })
                } else if (this.actions === "del" && this.selected.length === 0) {
                    this.showAlert('Необходимо выбрать хотя бы один товар', 'warning', 'toast');
                }
            }
        },

        data(){
            return{
                moment:moment,

                filter: {
                    to: '50',
                    price_from: '',
                    price_to: '',
                    new: false,
                    sale: false,
                    search: '',

                    category: null,
                    sub_category: null,
                    status: null,

                    stock_from: '',
                    stock_to: '',

                    sort: 'data-new',
                    trashed: false,

                    attributes: [],
                },

                modalProduct: {},
                selected: [],
                actions: null
            }
        },

        watch: {
            $route: function () {
                this.getFilter()
            },

            "filter.to": function() {
                this.getFilter()
            }
        },








    }
</script>

<style scoped>

</style>